import type { UpdatePrivateEventInput } from '../../api/private-event-update';
import type { PrivateEventDetail } from '../../api/privateEvents';

export interface AddOnsNotesDraft {
  addOns: string[];
  notes: string;
}

export function seedAddOnsNotes(event: PrivateEventDetail): AddOnsNotesDraft {
  return { addOns: event.addOns, notes: event.notes ?? '' };
}

const sameSet = (a: string[], b: string[]) =>
  a.length === b.length && a.every((id) => b.includes(id));

export function addOnsNotesPatch(
  seed: AddOnsNotesDraft,
  now: AddOnsNotesDraft,
): UpdatePrivateEventInput {
  const patch: UpdatePrivateEventInput = {};
  if (!sameSet(seed.addOns, now.addOns)) patch.addOns = now.addOns;
  if (now.notes.trim() !== seed.notes.trim()) patch.notes = now.notes.trim() || null;
  return patch;
}
